import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ValuationTool from "@/pages/ValuationTool";
import ResultsPage from "@/pages/ResultsPage";
import RecentSalesStatePage from "@/pages/RecentSalesStatePage";

function App() {
    return (
        <div className="App min-h-screen bg-white">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/cafe-valuer" element={<ValuationTool />} />
                    <Route path="/results" element={<ResultsPage />} />
                    <Route path="/recent-sales/:state" element={<RecentSalesStatePage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
